class FeaturedProductScroll extends HTMLElement {
  constructor() {
    super();

    // Store references to DOM elements
    this.productsContainer = null;
    this.leftArrow = null;
    this.rightArrow = null;
    this.progressBar = null;

    // Configuration
    this.scrollAmount = 300;

    // Bind methods to preserve 'this' context
    this.updateOverflowIndicators = this.updateOverflowIndicators.bind(this);
    this.handleLeftArrowClick = this.handleLeftArrowClick.bind(this);
    this.handleRightArrowClick = this.handleRightArrowClick.bind(this);
  }

  connectedCallback() {
    // This lifecycle hook runs when the element is added to the DOM
    this.initializeComponent();

    // Set up event listeners
    this.setupEventListeners();

    // Run initial update
    this.updateOverflowIndicators();
  }

  disconnectedCallback() {
    // This lifecycle hook runs when the element is removed from the DOM
    // Clean up event listeners to prevent memory leaks
    this.cleanupEventListeners();
  }

  initializeComponent() {
    // Find all necessary elements
    this.productsContainer = this.querySelector('.potw-scroll-container');
    this.leftArrow = this.querySelector('[data-overflow-indicator-left]');
    this.rightArrow = this.querySelector('[data-overflow-indicator-right]');
    this.progressBar = this.querySelector('.potw-progress-bar');

    // Initialize arrow visibility
    if (this.leftArrow) {
      this.leftArrow.classList.add('opacity-0');
    }
  }

  setupEventListeners() {
    // Setup scroll event listeners
    if (this.productsContainer) {
      this.productsContainer.addEventListener('scroll', this.updateOverflowIndicators);
    }

    // Setup resize event listener
    window.addEventListener('resize', this.updateOverflowIndicators);

    // Setup arrow click handlers
    if (this.leftArrow) {
      this.leftArrow.addEventListener('click', this.handleLeftArrowClick);
    }

    if (this.rightArrow) {
      this.rightArrow.addEventListener('click', this.handleRightArrowClick);
    }
  }

  cleanupEventListeners() {
    // Remove all event listeners
    if (this.productsContainer) {
      this.productsContainer.removeEventListener('scroll', this.updateOverflowIndicators);
    }

    window.removeEventListener('resize', this.updateOverflowIndicators);

    if (this.leftArrow) {
      this.leftArrow.removeEventListener('click', this.handleLeftArrowClick);
    }

    if (this.rightArrow) {
      this.rightArrow.removeEventListener('click', this.handleRightArrowClick);
    }
  }

  handleLeftArrowClick() {
    if (this.productsContainer) {
      this.productsContainer.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
    }
  }

  handleRightArrowClick() {
    if (this.productsContainer) {
      this.productsContainer.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
    }
  }

  updateOverflowIndicators() {
    if (!this.productsContainer) return;

    const maxScrollLeft = Math.max(0, this.productsContainer.scrollWidth - this.productsContainer.clientWidth);
    const currentScroll = this.productsContainer.scrollLeft;

    // Left arrow visibility
    if (this.leftArrow) {
      this.leftArrow.classList.toggle('opacity-0', currentScroll === 0);
    }

    // Right arrow visibility
    if (this.rightArrow) {
      this.rightArrow.classList.toggle('opacity-0', currentScroll >= maxScrollLeft);
    }

    // Update progress bar width
    if (this.progressBar && maxScrollLeft > 0) {
      const visibleRatio = (this.productsContainer.clientWidth / this.productsContainer.scrollWidth) * 100;
      const scrollPercentage = (currentScroll / maxScrollLeft) * 100;
      this.progressBar.style.width = `${Math.max(visibleRatio, Math.min(100, scrollPercentage))}%`;
    }
  }
}

// Register the custom element
customElements.define('featured-product-scroll', FeaturedProductScroll);
